import {
  Home,
  KeyboardArrowUp,
  Settings,
  TollOutlined,
} from "@mui/icons-material";
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  IconButton,
  Slide,
  Toolbar,
  useScrollTrigger,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

interface Props {
  window?: () => Window;
  children?: React.ReactElement<unknown>;
}

const Main: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const pages = ["Home", "Setting"];
  const [trigger, setTrigger] = React.useState(false);

  function HideOnScroll(props: Props) {
    const { children } = props;

    return (
      <Slide direction="down" in={trigger} mountOnEnter unmountOnExit>
        {children ?? <div />}
      </Slide>
    );
  }

  const startYRef = React.useRef(0);

  const wasAtTopRef = React.useRef(true);

  React.useEffect(() => {
    const onScroll = () => {
      const isAtTop = window.scrollY <= 0;

      if (isAtTop && !wasAtTopRef.current) {
        console.log("user reached top");
      }

      wasAtTopRef.current = isAtTop;
    };

    const onWheel = (e: WheelEvent) => {
      // deltaY < 0 表示用户继续向上滚轮
      const isAtTop = window.scrollY <= 0;

      if (isAtTop && e.deltaY < 0) {
        console.log("user keeps scrolling up at top");
        setTrigger(true);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("wheel", onWheel, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("wheel", onWheel);
    };
  }, []);

  React.useEffect(() => {
    const onTouchStart = (e: TouchEvent) => {
      startYRef.current = e.touches[0].clientY;
    };

    const onTouchMove = (e: TouchEvent) => {
      const currentY = e.touches[0].clientY;
      const pullingDown = currentY > startYRef.current;
      const isAtTop = window.scrollY <= 0;

      if (isAtTop && pullingDown) {
        console.log("user keeps pulling at top");
        setTrigger(true);
      }

      startYRef.current = currentY;
    };

    window.addEventListener("touchstart", onTouchStart, { passive: true });
    window.addEventListener("touchmove", onTouchMove, { passive: true });

    return () => {
      window.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchmove", onTouchMove);
    };
  }, []);

  return (
    <>
      <CssBaseline />
      <HideOnScroll>
        <AppBar position="fixed" enableColorOnDark>
          <Toolbar variant="dense" sx={{ justifyContent: "space-between" }}>
            <Box width={34} />
            <Box>
              <IconButton size="small">
                <Link to="/" className="text-slate-700 hover:text-slate-900">
                  <Home />
                </Link>
              </IconButton>
              <IconButton size="small">
                <Link
                  to="/setting"
                  className="text-slate-700 hover:text-slate-900"
                >
                  <Settings />
                </Link>
              </IconButton>
            </Box>
            <IconButton
              onClick={() => {
                setTrigger(false);
              }}
              size="small"
            >
              <KeyboardArrowUp />
            </IconButton>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      {trigger && <Toolbar variant="dense" />}

      <Container component={"main"} className="my-4">
        {children}
      </Container>
    </>
  );
};

export default Main;
